import {useQuery, useQueryClient} from '@tanstack/react-query';

import {useCommerceAPI} from 'commerceAPI/contexts';
import useLanguageCode from 'coreHooks/locales/useLanguageCode';

import {getCategoriesQueryKey, fetchCategoryTree} from 'coreUtils/categories';
import {useCustomerMgr} from 'coreHooks';

import useIsCategoryTreeLoaded from './useIsCategoryTreeLoaded';

/**
 * Fetches the full category tree when the React Query cache for the
 * current language is empty (no `root` entry). No-op when SSR has
 * already hydrated categories for that language.
 */
export default function useFetchAllCategories(): void {
	const queryClient = useQueryClient();
	const commerceApi = useCommerceAPI();
	const languageCode = useLanguageCode();
	const queryKey = getCategoriesQueryKey(languageCode);
	const isCacheEmpty = !useIsCategoryTreeLoaded(languageCode);
	const customerMgr = useCustomerMgr();
	const customer = customerMgr.getCurrentCustomer();

	useQuery({
		queryKey,
		queryFn: () => fetchCategoryTree('root', commerceApi, queryClient, languageCode),
		enabled: !!languageCode && isCacheEmpty && customer.isReady(),
		staleTime: Infinity,
	});
}
